// extracted by mini-css-extract-plugin
export var container = "FlipButton-module--container--85a5b";
export var flipped = "FlipButton-module--flipped--72815";
export var icon = "FlipButton-module--icon--4e04f";